import Icon from '@/components/icons/Icon';
import { IconVariant } from '@/components/icons/types';

const ITEM_IMAGE_SIZE = {
  sm: 40,
  md: 56,
  lg: 96,
};

const ICON_SIZE = {
  sm: 24,
  md: 32,
  lg: 56,
};

type ItemImageProps = {
  icon: IconVariant;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

const ItemImage = ({ icon, size = 'md', className }: ItemImageProps) => {
  return (
    <div
      className={`bg-bg_brand grid place-content-center rounded-full ${className}`}
      style={{ width: ITEM_IMAGE_SIZE[size], height: ITEM_IMAGE_SIZE[size] }}>
      <Icon variant={icon} color="fg_alwaysLight" style={{ width: ICON_SIZE[size], height: ICON_SIZE[size] }} />
    </div>
  );
};

export default ItemImage;
